var indexOf = [].indexOf;

angular.module('app.controllers').controller('ExhibitorsListCtrl', ['$scope', '$location', 'UI', 'APIRead2Table', '$rootScope', '$cookies', 'Table', 'APIRead2', '$http', 'smoothScr', '$timeout'].append(function(self, $location, UI, APIRead2Table, root, $cookies, Table, APIRead2, $http, smoothScr, $timeout) {
  var cookiesName, count_type, defaultParams, dropdownLocation, dropdownSearch, previewParams, ref, tableName, tempParams;
  if (self.at('jobs')) {
    self.sourceRoute = 'open_jobs';
    count_type = 'open_jobs';
  } else if (self.at('talent')) {
    self.sourceRoute = 'talents';
    count_type = 'talents';
  } else {
    self.sourceRoute = 'exhibitors';
    count_type = 'exhibitors';
  }
  // laod counts for training paths only on exhibitor page
  APIRead2.query({
    entry_type: 'training_paths',
    with_count: true,
    type: 'full',
    count_table: 'entries',
    count_type: count_type
  }, function(data) {
    return self.topstat = data;
  }, function(response) {
    return UI.notify(false, response.error.data);
  });
  APIRead2.query({
    entry_type: 'presenter',
    type: 'full',
    nogroup: true
  }, function(data) {
    return self.data1 = data;
  }, function(response) {
    return UI.notify(false, response.error.data);
  });
  
  // Location functionality

  self.locationSelected = false;
  self.$watch('tempParams.location.point', function(newObj, oldObj) {
    if (!((newObj != null ? newObj.length : void 0) > 0)) {
      return self.tempParams.location.address = "";
    }
    return self.preview.params.location = newObj.filter(Boolean).join("|");
  }, true);
  self.getLocationDetail = function(prediction = null, coords = null, callback = false) {
    var geocoder, params;
    geocoder = new google.maps.Geocoder();
    params = {};
    if (prediction != null) {
      params.placeId = prediction.place_id;
    } else {
      params.latLng = new google.maps.LatLng(coords);
    }
    return geocoder.geocode(params, function(results, status) {
      if (status === google.maps.GeocoderStatus.OK) {
        results = results.filter(function(res) {
          return indexOf.call(res.types, "locality") >= 0 || indexOf.call(res.types, "political") >= 0;
        });
        if (results[0]) {
          self.tempParams.location = {
            point: [results[0].geometry.location.lat(), results[0].geometry.location.lng()],
            address: prediction != null ? prediction.description : results[0].formatted_address
          };
          if (prediction == null) {
            // clear predictions list if user click on "get my location"
            self.predictions = null;
          }
          // location geocoded 
          self.isLocChanged = false;
          return self.$applyAsync();
        } else {
          self.tempParams.location = {
            point: [],
            address: ""
          };
          return UI.notify(false, 'No results found');
        }
      } else {
        self.tempParams.location = {
          point: [],
          address: ""
        };
        return UI.notify(false, 'Geocoder failed due to: ' + status);
      }
    });
  };
  self.getCurrentLocation = function(api = false) {
    var url;
    if (navigator.geolocation && !api) {
      return navigator.geolocation.getCurrentPosition(function(position) {
        //self.tempParams.location.point = [position.coords.latitude, position.coords.longitude]
        return self.getLocationDetail(null, {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      }, function(response) {
        return self.getCurrentLocation(true);
      });
    } else {
      url = "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBwYHHt1Uxa-K46nWa3PdAWtG444TmN_9k";
      return $http.post(url, {}).then(function(response) {
        //self.tempParams.location.point = [response.data.location.lat, response.data.location.lng]
        return self.getLocationDetail(null, {
          lat: response.data.location.lat,
          lng: response.data.location.lng
        });
      }, function(response) {
        return UI.notify(false, response.data.error.message);
      });
    }
  };
  self.setPredictionLocation = function(prediction) {
    return self.getLocationDetail(prediction);
  };
  self.isLocChanged = false;
  self.locationChanged = function() {
    var service;
    if (!(self.tempParams.location.address.length > 3)) {
      return;
    }
    self.isLocChanged = true;
    service = new google.maps.places.AutocompleteService();
    return service.getPlacePredictions({
      input: self.tempParams.location.address,
      types: ['locality']
    }, function(predictions, status) {
      var ref;
      if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
        UI.notify(false, status);
        return;
      }
      self.predictions = predictions;
      if ((ref = self.dropdownLO) != null) {
        ref.show();
      }
      return self.$apply();
    });
  };
  self.searchKey = function($event, dropdown) {
    if ($event.keyCode === 13) {
      self.applyFilter();
      if (dropdown === "dropdownSE") {
        return self.dropdownSE.hide();
      }
    } else {
      if (dropdown === "dropdownSE") {
        return self.dropdownSE.show();
      }
    }
  };
  dropdownSearch = document.getElementById('searchDropdown');
  if (dropdownSearch) {
    self.dropdownSE = bootstrap.Dropdown.getOrCreateInstance(dropdownSearch);
  }
  dropdownLocation = document.getElementById('locationDropdown');
  if (dropdownLocation) {
    self.dropdownLO = bootstrap.Dropdown.getOrCreateInstance(dropdownLocation);
    dropdownLocation.addEventListener('hide.bs.dropdown', function(event) {
      return self.$applyAsync();
    });
  }
  tableName = 'jub.e.' + (((ref = root.user) != null ? ref.shortcode : void 0) || 'test');
  cookiesName = 't.' + tableName;
  defaultParams = {
    og: "",
    se: "",
    co: "",
    ap: "",
    tp: "",
    tm: "",
    search: "",
    location: "",
    distance: "5"
  };
  tempParams = $cookies.getObject(cookiesName) || defaultParams;
  (self.clearParams = function(source) {
    var loc, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    loc = ((ref1 = source.location) != null ? ref1.split("|").filter(Boolean).map(Number) : void 0) || [];
    self.tempParams = {
      og: ((ref2 = source.og) != null ? ref2.split("|").filter(Boolean).map(Number) : void 0) || [],
      se: ((ref3 = source.se) != null ? ref3.split("|").filter(Boolean).map(Number) : void 0) || [],
      co: ((ref4 = source.co) != null ? ref4.split("|").filter(Boolean).map(Number) : void 0) || [],
      ap: ((ref5 = source.ap) != null ? ref5.split("|").filter(Boolean).map(Number) : void 0) || [],
      tp: ((ref6 = source.tp) != null ? ref6.split("|").filter(Boolean) : void 0) || [],
      tm: ((ref7 = source.tm) != null ? ref7.split("|").filter(Boolean).map(Number) : void 0) || [],
      search: source.search,
      location: {
        point: loc,
        address: ""
      },
      distance: String(source.distance || 5)
    };
    if (loc.length > 0) {
      return self.getLocationDetail(null, {
        lat: loc[0],
        lng: loc[1]
      });
    }
  })(tempParams);
  self.paramsToQuery = function() {
    var ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return {
      og: ((ref1 = self.tempParams.og) != null ? ref1.join("|") : void 0) || "",
      se: ((ref2 = self.tempParams.se) != null ? ref2.join("|") : void 0) || "",
      co: ((ref3 = self.tempParams.co) != null ? ref3.join("|") : void 0) || "",
      ap: ((ref4 = self.tempParams.ap) != null ? ref4.join("|") : void 0) || "",
      tp: ((ref5 = self.tempParams.tp) != null ? ref5.join("|") : void 0) || "",
      tm: ((ref6 = self.tempParams.tm) != null ? ref6.join("|") : void 0) || "",
      search: self.tempParams.search,
      location: ((ref7 = self.tempParams.location) != null ? ref7.point.join("|") : void 0) || "",
      distance: self.tempParams.distance
    };
  };
  self.data = Table({
    name: tableName,
    type: "partial",
    resource: APIRead2Table,
    params: {
      da: "",
      entry_type: self.sourceRoute,
      exclude: self.at('talent') ? 819655 : ''
    }
  });
  self.filterCount = 0;
  self.$watch('data.params', function(newObj, oldObj) {
    self.page = 1;
    return self.filterCount = self.tempParams.tp.length + self.tempParams.og.length + self.tempParams.se.length + self.tempParams.co.length + self.tempParams.ap.length;
  }, true);
  previewParams = angular.copy(tempParams);
  previewParams.page = 1;
  previewParams.da = "";
  if (!previewParams.distance) {
    previewParams.distance = "5";
  }
  previewParams.entry_type = self.sourceRoute;
  self.preview = Table({
    name: `${tableName}.temp`,
    type: "partial",
    resource: APIRead2Table,
    cookies: false,
    params: previewParams
  });
  self.$watch('preview.params.search', function(newObj, oldObj) {
    return self.sugg.params.search = newObj;
  }, true);
  self.sugg = Table({
    name: `${tableName}.sugg`,
    type: "partial",
    resource: APIRead2Table,
    cookies: false,
    params: {
      da: "",
      limit: 5,
      entry_type: self.sourceRoute
    }
  });
  self.page = 1;
  self.loadMore = function() {
    var params;
    if (self.page >= self.data.data.pages) {
      return;
    }
    self.page++;
    params = angular.copy(self.data.params);
    params.page = self.page;
    self.moreLoad = true;
    return APIRead2.query(params, function(data) {
      self.more = data;
      self.data.data.display = self.data.data.display.concat(self.more);
      return self.moreLoad = false;
    });
  };
  self.setDistance = function(distance) {
    if (self.preview.params.distance === distance) {
      return;
    }
    return self.preview.params.distance = distance;
  };
  self.filterChanged = function(key) {
    return self.preview.params[key] = self.tempParams[key].filter(Boolean).join("|");
  };
  //if key is 'tp'
  //  self.data.params[key] = self.preview.params[key]
  self.resetFilter = function() {
    self.clearParams(angular.copy(defaultParams));
    return self.applyFilter(true);
  };
  self.applyFilter = function(reset = false) {
    if (self.isLocChanged) {
      if (self.predictions != null) {
        self.getLocationDetail(self.prediction[0], null);
      }
    }
    if (reset) {
      angular.extend(self.preview.params, self.paramsToQuery(self.tempParams));
    }
    angular.extend(self.data.params, self.preview.params);
    return $timeout(function() {
      return smoothScr.scroll('#table', 0);
    });
  };
  self.saveForm = function(form) {
    return self.feForm = form;
  };
  self.$on('reloadData', function(event) {
    var newParams;
    newParams = $cookies.getObject(cookiesName);
    self.clearParams(newParams);
    angular.extend(self.preview.params, newParams);
    return angular.extend(self.data.params, newParams);
  });
  self.activeFilter = function(item, index, array) {
    var ref1, ref2;
    if ((ref1 = item.entry_code) === 'tm' || ref1 === 'be' || ref1 === 'tp') {
      return false;
    }
    return ref2 = item.entry_id, indexOf.call(self.tempParams[item.entry_code], ref2) >= 0;
  };
  self.removeFilter = function(item) {
    var ind;
    ind = self.tempParams[item.entry_code].indexOf(item.entry_id);
    if (!(ind >= 0)) {
      return;
    }
    self.tempParams[item.entry_code].splice(ind, 1);
    return self.applyFilter(true);
  };
  return self.setTp = function(entry_id) {
    var params;
    params = {
      og: "",
      se: "",
      co: "",
      ap: "",
      tp: `${entry_id}`,
      tm: "",
      search: "",
      location: "",
      distance: 5
    };
    self.clearParams(params);
    return self.applyFilter(true);
  };
}));
